import { AgGridModule } from '@ag-grid-community/angular';
import { ColDef, ModuleRegistry, ValueFormatterParams } from '@ag-grid-community/core';
import { ServerSideRowModelModule } from '@ag-grid-enterprise/server-side-row-model';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import { StatusBarModule } from '@ag-grid-enterprise/status-bar';
import { CommonModule } from '@angular/common';
import { Component, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ImportsMonitoringItem } from 'exports/interfaces/imports-monitoring-channel.interface';
import { ImportsMonitoringService } from 'exports/services/imports-monitoring.service';
import { BaseGrid } from 'shared/abstract/base-grid';

@Component({
    selector: 'app-imports-monitoring-channel-overview',
    imports: [TranslateModule, AgGridModule, CommonModule],
    templateUrl: './imports-monitoring-channel-overview.component.html',
    styleUrl: './imports-monitoring-channel-overview.component.scss',
})
export class ImportsMonitoringChannelOverviewComponent extends BaseGrid {
    public columnDefs: ColDef[] = [
        {
            field: 'sourceName',
            headerName: 'Source',
            cellRenderer: 'distributionTrackingChannelLogoCellRenderer',
            valueFormatter: (params: ValueFormatterParams) => {
                return params.data.channelName;
            },
            cellRendererParams: ((params: any) => {
                return {
                    linkUrl: `/export-management/imports-monitoring/${params.data.id}`,
                };
            }) as any,
            sort: 'asc',
            sortIndex: 0,
        },
        { field: 'lastImportDateOutput', valueFormatter: this.unixDateFormatter },
        {
            headerName: 'Status',
            field: 'successRate',
            cellRenderer: 'importPartialSuccessStatusBarRenderer',
            enableValue: true,
        },
        {
            colId: 'actions',
            filter: false,
            resizable: false,
            sortable: false,
            minWidth: 110,
            maxWidth: 110,
            cellRenderer: 'actionButtonsCellRenderer',
            cellRendererParams: {
                buttons: [
                    {
                        clickAction: this.openChannelDetailClickHandler.bind(this),
                        icon: 'chevron-right',
                        tooltip: this.translateService.instant('exports.monitoring.viewChannelDetails'),
                    },
                ],
            },
        },
    ];

    constructor(
        router: Router,
        activatedRoute: ActivatedRoute,
        destroyRef: DestroyRef,
        public importsMonitoringService: ImportsMonitoringService,
        private translateService: TranslateService,
    ) {
        ModuleRegistry.registerModules([ServerSideRowModelModule, StatusBarModule, SetFilterModule]);
        super(importsMonitoringService, router, activatedRoute, destroyRef);
    }

    public openChannelDetailClickHandler(rowData: ImportsMonitoringItem) {
        this.router.navigate([rowData.id], {
            relativeTo: this.activatedRoute,
        });
    }
}
